<ng-container *ngIf="mode === VIEW_MODES.RISK_REGISTER" #riskRegisterContainer>
  <ng-container *ngTemplateOutlet="riskRegister"></ng-container>
</ng-container>
<ng-container *ngIf="mode === VIEW_MODES.RISK_ADD">
  <ng-container *ngTemplateOutlet="addRisk"></ng-container>
</ng-container>

<ng-template #riskRegister id="risk-register">
  <div class="sticky !bg-[#fff] top-0 !p-0">
    <div
      class="flex justify-between items-center !bg-[#dee2e6] p-4 !pl-[31px] !pr-[40px]"
    >
      <div class="flex justify-start items-center gap-8 !bg-[#dee2e6]">
        <h3 class="project-plan">Project Plan</h3>
        <span
          class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
          >Risk Register</span
        >
      </div>
      <!-- Close Icon -->
      <div
        style="position: absolute; top: 10px; right: 36px; z-index: 50"
        (click)="closeDialog()"
      >
        <img
          src="assets/icons/cross-icon.svg"
          alt="cross icon"
          class="cursor-pointer !fixed"
        />
      </div>
    </div>
    <div class="flex justify-end">
      <app-progress-bar
        [progress]="stage2Progress"
        [sectionId]="'section2'"
        [selectedSection]="selectedSection"
        [sectionName]="'Project Plan'"
      >
      </app-progress-bar>
    </div>
  </div>
  <div class="pt-[6px] pr-6 pb-6 pl-6! px-[40px]">
    <button class="add_new_button" (click)="showAddRiskDialog()">
      <span>+</span>Add New
    </button>

    <div
      id="risk-register-content"
      class="flex justify-center h-[100%] w-[100%]"
    >
      <div class="w-[100%] h-[100%] flex flex-col justify-between">
        <div>
          <div class="table-scroll">
            <div class="main-section m-2 !mx-0">
              <table class="w-full table-auto table-striped">
                <thead style="width: 100%; background: #dee2e6">
                  <tr class="sticky !z-20 top-0">
                    <th
                      class="text-left"
                      style="justify-items: left !important; text-align: left"
                    >
                      Description
                    </th>
                    <th class="text-left" style="width: 11%">Category</th>
                    <th class="text-left" style="width: 10%">Likelihood</th>
                    <th class="!text-center items-center">Impact</th>
                    <th class="text-left" style="width: 10%">Rating</th>
                    <th
                      class="text-left"
                      class="text-left"
                      style="justify-items: left !important; text-align: left"
                    >
                      Mitigation
                    </th>
                    <th class="!text-left" style="width: 8%">Owner</th>
                    <th class="text-left" style="width: 10%">Date</th>
                    <th
                      class="text-left"
                      style="width: 10%; justify-items: left"
                    >
                      Status
                    </th>
                    <th class="text-left" style="width: 10%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let risk of allRiskData">
                    <td
                      class="text-left"
                      style="justify-items: left !important; text-align: left"
                      [innerHTML]="getSanitizedHtml(risk.description)"
                    ></td>
                    <td class="text-left">{{ risk?.risk_category }}</td>
                    <td class="text-left">{{ risk.likelihood }}</td>
                    <td class="!text-center">{{ risk.impact }}</td>
                    <td
                      class="text-left"
                      [ngStyle]="{
                        'background-color':
                          risk.risk_rating > 10 ? 'red' : 'green',
                        color: 'white'
                      }"
                    >
                      {{ risk.risk_rating }}
                    </td>

                    <td
                      class="text-left"
                      style="justify-items: left !important; text-align: left"
                      [innerHTML]="getSanitizedHtml(risk.mitigation_strategy)"
                    ></td>
                    <td class="!text-left">{{ risk?.risk_owner }}</td>
                    <td class="text-left">{{ risk.target_resolution_date }}</td>
                    <td class="text-left">{{ risk.status }}</td>
                    <td
                      class="text-left"
                      style="justify-items: center !important"
                    >
                      <img
                        class="w-[1.5rem] h-[1.5rem]"
                        src="assets/icons/action.png"
                        alt="action icon"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="sticky">
          <div
            class="w-[100%] flex justify-between items-center mb-[1rem] mt-[21px]"
          >
            <div class="flex items-center">
              <button
                type="button"
                class="bg-[#e76b3f] text-[16px] rounded-[3px] text-white w-[180px] h-[48px]"
                mat-button
                (click)="handleProjectStage2Approval()"
                [ngClass]="
                  approvalDetails.length > 0 &&
                  approvalDetails[0].parentStatus !== 'pending'
                    ? '!bg-[#197741] !border-[#197741]'
                    : ''
                "
              >
                <span>{{
                  approvalDetails.length > 0
                    ? "Approval Status"
                    : "Send For Approval"
                }}</span>
              </button>
            </div>
            <!-- isStageOneSendForApproval -->
            <div class="flex justify-end">
              <button (click)="handleBack()" type="button" class="back-btn">
                Back
              </button>
              <button class="next-btn" type="button" (click)="closeDialog()">
                Save & Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addRisk>
  <add-risk
    (changeToRiskRegister)="onChangeToRiskRegister($event)"
    [riskCategories]="riskCategories"
  ></add-risk>
</ng-template>
